// src/services/cdrRecordingService.js
import axios from 'axios'

/**
 * New endpoint (no DB hit):
 * GET /api/cdr/recording?customer_id=1000004&filename=1769293311.131.wav
 *
 * Response:
 * { has_recording: true, url, customer_id, filename, s3_key, expires_at }
 */
export default {
  async getRecording(input) {
    if (typeof input === 'string' || typeof input === 'number') {
      const id = String(input).trim()
      throw new Error(
        `CdrRecordingService.getRecording expects { customer_id, filename } (new route). Received legacy id=${id}`
      )
    }

    // accept a couple common aliases so UI code can’t accidentally break this
    const customer_id = String(
      input?.customer_id ?? input?.customerId ?? input?.accountcode ?? input?.accountCode ?? ''
    ).trim()

    const filename = String(input?.filename ?? '').trim()

    if (!customer_id || !filename) {
      throw new Error(
        `Missing params for recording lookup. customer_id="${customer_id}", filename="${filename}"`
      )
    }

    const res = await axios.get('/cdr/recording', {
      params: { customer_id, filename }
    })

    return res.data
  }
}
